import {Action} from '@ngrx/store';
import {ListPaneType} from '../enums/list-pane-type.enum';

export enum DashboardViewActionTypes {
  SwitchListPane = '[DashboardView] Switch List Pane'
}

export class SwitchListPane implements Action {
  readonly type = DashboardViewActionTypes.SwitchListPane;

  constructor(public payload: ListPaneType) {
  }
}

export type DashboardViewActions =
  | SwitchListPane;
